/** The board's shortcut commands and Edit menu lines (they act only while the board is shown). */
import type { CommandSet } from "../../shared/commands";
import type { MenuSection } from "../../shared/menus";
import type { View } from "../view";
import type { Board, BoardTool } from "./types";

/** The board's shortcut commands (they do nothing outside the board). */
export function boardCommands(board: Board, view: View): CommandSet {
  /** Runs `then` only while the board is shown. */
  const on = (then: () => unknown) => () => void (view.mode() === "board" && then());
  return {
    "board.tool": (tool) => view.mode() === "board" && board.tools().some((t) => t.id === tool) && board.setTool(tool as BoardTool),
    "board.duplicate": on(() => board.duplicate()),
    "board.group": on(() => board.group()),
    "board.ungroup": on(() => board.ungroup()),
    "board.front": on(() => board.order("front")),
    "board.back": on(() => board.order("back")),
    "board.export": on(() => board.exportImage()),
  };
}

/** The board's Edit lines (shown only while it is). */
export function boardMenus(board: Board, view: View): MenuSection[] {
  return [
    {
      menu: "edit",
      section: "Board",
      order: 30,
      entries: () => {
        if (view.mode() !== "board") return [];
        const many = board.selected().length > 1;
        return [
          { label: "Duplicate", command: "board.duplicate", disabled: !board.selected().length },
          { label: "Group", command: "board.group", disabled: !many },
          { label: "Ungroup", command: "board.ungroup" },
          { label: "Bring to front", command: "board.front", disabled: !board.selected().length },
          { label: "Send to back", command: "board.back", disabled: !board.selected().length },
          { label: board.selected().length ? "Export the selection as an image…" : "Export the board as an image…", command: "board.export" },
        ];
      },
    },
  ];
}
